import { getEnvVariable } from '@/shared/lib/getEnvVariable'
import { useDIService } from '@/app/context/DIContext/useDIService'

export const useService = <T>(envKey: string) => {
    const envVariable = getEnvVariable(envKey)
    const service = useDIService<T>(envVariable)
    return service
}
